App.controller('ProfileCtrl', ['$scope', '$rootScope', '$sce', '$state', '$http', 'profileService', 'Config', '$mdDialog', 'statesService', '$filter', 'branchService', 'dataUser', '$q', 'popUpService', 'authService', function ($scope, $rootScope, $sce, $state, $http, profileService, Config, $mdDialog, statesService, $filter, branchService, dataUser, $q, popUpService, authService) {
    $scope.page = 'profile';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Twój profil';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope._userData = {};
    $scope._userDeatails = {};

    $scope.canChangeAddress = false;

    $scope.branches = [];
    $scope.selectedBranch = null;

    profileService.dataPerson().then(function (data) {
        $scope.userData = data.data;
        $scope._userData = angular.copy(data.data);
        $scope.userData.birthdate = $filter('dateFormatter')($scope.userData.birthdate);

        if ($scope.userData.address) {
            $scope.selectedItemLocalization = $scope.userData.address.city;
        }
    });
    profileService.dataUser().then(function (data) {
        $scope.userDetails = data.data;
        $scope._userDeatails = angular.copy(data.data);

        branchService.dataBranchLists().then(function (data) {
            $scope.branches = $filter('hideBranchCargo')(data.data.data);
            if (_.findIndex($scope.branches, {id: $scope.userDetails.branch.id}) >= 0) {
                $scope.selectedBranch = $scope.userDetails.branch;
            }
        });
    });

    $scope.observeCanChangeAddress = function() {
        if (!$scope.canChangeAddress) {
            $scope.userData.address = $scope._userData.address;
        }
    };

    $scope.edit = function () {
        var vm = this;

        if (!vm.form.$valid) {
            $scope.showPopUp('', 'Uzupełnij wymagane pola', 'Popraw albo wypełnij wszystkie wymagane pola.', '');
            return 0;
        }

        $scope.data = {
            address: {
                street: $scope.userData.address.street,
                city: $scope.userData.address.city,
                number: $scope.userData.address.number,
                apartment: $scope.userData.address.apartment,
                zipCode: $scope.userData.address.zipCode,
                post: $scope.userData.address.post
            },
            branchId: $scope.selectedBranch.id,
            lastName: $scope.userData.lastName,
            password: $scope.password_current,
            email: $scope.userData.email,
            hrNumber: $scope.userData.hrNumber,
            login: $scope.userDetails.login,
            phone: $scope.userData.phone
        };

        var withLogout = false;
        if ($scope.userDetails.login !== $scope._userDeatails.login) {
            withLogout = true;
        }
        var emailChanged = false;
        if ($scope.userData.email !== $scope._userDeatails.email && $scope._userDeatails.branch.company.userVerificationRequired) {
            withLogout = true;
            emailChanged = true;
        }

        $scope.data.birthplace = $scope.userData.birthplace; // add birthplace despite if it is defined or not

        profileService.editUser($scope.data).then(function (data) {
            if (data.status === 200) {
                $scope.password_current = '';
                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;

                dataUser.update();

                if (withLogout) {
                    if (emailChanged) {
                        $scope.showPopUp('', 'Dane zmieniono pomyślnie', 'Wprowadzone dane zostały zapisane pomyślnie. Aby potwierdzić zmianę adresu e-mail kliknij w link znajdujący sie w wysłanej wiadomości e-mail.', '', '');
                    } else {
                        $scope.showPopUp('', 'Zmiana danych logowania', 'Twój login został poprawnie zmieniony. Zaloguj się ponownie używając nowych danych.', '', '');
                    }
                    logout();
                } else {
                    $scope.showPopUp('', 'Dane zmieniono pomyślnie', 'Wprowadzone dane zostały zapisane pomyślnie.', 'Wróć do strony głównej', 'root.dashboard');
                }

            } else {
                errorCallback(data.data);
            }
        }, function (error) {
            errorCallback(error.data);
        });
    };

    function errorCallback(error){
        error = error || {};
        error.message = error.message || '';

        if (error.message === 'DuplicateLoginException') {
            popUpService.showPopUpWithError(error, {ev: '', head: 'Niepoprawny login', content: 'Podany login nie może zostać użyty. Podaj inny.', text: '', target: ''});
        } else if (error.message === 'DuplicateEmailException') {
            popUpService.showPopUpWithError(error, {ev: '', head: 'Nie zmieniono danych', content: 'Podany adres e-mail jest już zajęty, użyj innego.', text: '', target: ''});
        } else if (error.message === 'DuplicatePhoneException') {
            popUpService.showPopUpWithError(error, {ev: '', head: 'Nie zmieniono danych', content: 'Podany numer telefonu jest już zajęty, użyj innego.', text: '', target: ''});
        } else if (error.message === 'DuplicateHRNumberException') {
            popUpService.showPopUpWithError(error, {ev: '', head: 'Uwaga', content: 'Wskazany ' + $rootScope.CONFIGURATOR.hrNumber.nameLong + ' został już przypisany do innego użytkownika. Sprawdź poprawność numeru i spróbuj ponownie. W przypadku problemów prosimy o kontakt z naszą Infolinią.', text: '', target: ''});
        } else {
            popUpService.showPopUpWithError(error, {head: 'Nie zmieniono danych', content: 'Wprowadziłeś błędne hasło lub dane są nieprawidłowe, spróbuj ponownie.', text: 'OK'});
        }
    }

    function PopUpInfoCtrl(scope, $mdDialog, locals) {
        scope.locals = locals;

        scope.hide = function () {
            $mdDialog.hide();
        };

        scope.cancel = function () {
            $mdDialog.cancel();
        };

        scope.confirm = function () {
            $mdDialog.hide(scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['scope', '$mdDialog', 'locals'];
    $scope.showPopUp = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    // ##### FILTER ##### //
    $scope.onSelectedBranchChanged = function(item) {
        console.log("onSelectedBranchChanged " + JSON.stringify(item))
        $scope.selectedBranch = item;
    }

    $scope.querySearchBranch = function (query) {
        var results = query ? $scope.branches.filter(createFilterForItem(query)) : $scope.branches;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    $scope.deleteAccount = function () {
        $scope.showPopUpConfirm('', 'Czy potwierdzasz usunięcie konta?', 'Usunięcie konta oznacza rozwiązanie umowy o świadczenie usług drogą elektroniczną. Wiąże się to z brakiem możliwości korzystania z wykupionych produktów! Operacja jest nieodwracalna.', '', '');
    }

    $scope.showPopUpConfirm = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpConfirmCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/confirm-small.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpConfirmCtrl(scope, $mdDialog, locals) {
        scope.locals = locals;

        scope.hide = function () {
            $mdDialog.hide();
        };

        scope.cancel = function () {
            $mdDialog.cancel();
        };

        scope.confirm = function () {
            profileService.deleteAccount().then(function (data) {
                if (data.status === 200) {
                    $mdDialog.hide(scope.locals);
                    $state.go('root.login');
                }
            });
        };
    }

    function logout() {
        authService.logout().then(function (data) {
            if (data.status === 200) {
                dataUser.clearSession();
                $state.go('root.login');
            } else {
                dataUser.clearSession();
                $state.go('root.login');
            }
        });
    }
}]);
